import * as React from 'react';
// tslint:disable-next-line:ordered-imports
import { GrabFormModel, ServiceModel, UspModel, BenefitModel, ConclusionModel, WorkModel, ReviewModel, ProjectModel } from '../../../../models'
import Controller, { IAbstractDashboardControllerProps } from '../../common/CommonDashboardController';
import View from './ServiceAddEditView';

interface IServiceAddEditViewControllerState extends Interfaces.IViewControllerState {
    service: ServiceModel
    isNextStepAfterServiceCreationDialogOpen: boolean
    benefitSearchResult: BenefitModel[]
    postUspSearchResult: ConclusionModel[]
    uspSearchResult: UspModel[],
    formSearchResult: GrabFormModel.default[],
    reviewSearchResult: ReviewModel[],
    workSearchResult: WorkModel[],
    firendlyServiceSearchResult: ServiceModel[]
    projectSearchResult: ServiceModel[]
}

class ServiceAddEditViewController<P, S> extends Controller<P, S & IServiceAddEditViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Создание услуги'
    }

    constructor(props: any) {
        super(props)
        this.state = {
            logicError: '',
            service: new ServiceModel(),
            isNextStepAfterServiceCreationDialogOpen: false,
            uspSearchResult: [],
            benefitSearchResult: [],
            postUspSearchResult: [],
            formSearchResult: [],
            reviewSearchResult: [],
            workSearchResult: [],
            firendlyServiceSearchResult: [],
            projectSearchResult: [],
        } as any;
    }

    public goBack() {
        const { service } = this.state;
        service.usp = service.usp && service.usp.value ? service.usp.value : service.usp;
        service.conclusion = service.conclusion && service.conclusion.value ? service.conclusion.value : service.conclusion;
        service.grabForm = service.grabForm && service.grabForm['value'] ? service.grabForm['value'] : service.grabForm;
        service.benefits = service.benefits.map((b: any) => {
            return b ? b.value : b
        })
        service.works = service.works.map((b: any) => {
            return b ? b.value : b
        })
        service.friendlyServices = service.friendlyServices.map((b: any) => {
            return b ? b.value : b
        })
        service.projects = service.projects.map((b: any) => {
            return b ? b.value : b
        })
        service.reviews = service.reviews.map((b: any) => {
            return b ? b.value : b
        })
        super.goBack();
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true } as any);
        const serviceId = this.props.history['location']['state'] ? this.props.history['location']['state']['serviceId'] : null;
        let service = this.state.service;
        const backedService = this.props.history['location']['state'] ? this.props.history['location']['state']['service'] : null;
        if (backedService && backedService instanceof ServiceModel) {
            service = backedService as any;
        }
        if (serviceId) {
            service = await ServiceModel.loadService(serviceId) as any;
            service.usp = service.usp && !service.usp.value ? { label: service.usp.name, value: service.usp } : service.usp
            service.grabForm = service.grabForm && !service.grabForm['value'] ? { label: service.grabForm.name, value: service.grabForm } : service.grabForm
            service.conclusion = service.conclusion && !service.conclusion.value ? { label: service.conclusion.name, value: service.conclusion } : service.conclusion
            service.benefits = service.benefits.length ? service.benefits.map((b: any) => {
                return !b.value ? { label: b['name'], value: b } : b
            }) : []
            service.friendlyServices = service.friendlyServices.length ? service.friendlyServices.map((b: any) => {
                return !b.value ? { label: b['title']['ru'], value: b } : b
            }) : []
            service.projects = service.projects.length ? service.friendlyServices.map((b: any) => {
                return !b.value ? { label: b['title']['ru'], value: b } : b
            }) : []
            service.works = service.works.length ? service.works.map((b: any) => {
                return !b.value ? { label: b['adminName'], value: b } : b
            }) : []
            service.reviews = service.reviews.length ? service.reviews.map((b: any) => {
                return !b.value ? { label: b['name'], value: b } : b
            }) : []
        }
        this.setState({ service, loading: false } as any);
    }

    public onCreateContent(t: string) {
        this.props.history['replace'](`/${t}/add`, { service: this.state.service })
    }

    public async onSearchContent(s: string, t: string) {
        const { service } = this.state;
        switch (t) {
            case 'Usp':
                let usps = await UspModel.searchUsp(s, 10000, 0)
                if (service.usp) {
                    usps = usps['filter']((u: any) => u.id !== service.usp.value.id)
                }
                this.setState({ uspSearchResult: s ? usps as UspModel[] : [] } as any);
                break;
            case 'GrabForm':
                let grabForms = await GrabFormModel.default.search(s, 10000, 0)
                if (service.grabForm && service.grabForm.value) {
                    grabForms = grabForms['filter']((u: any) => u.id !== service.grabForm.value.id)
                }
                this.setState({ formSearchResult: s ? grabForms as GrabFormModel.default[] : [] } as any);
                break;
            case 'Works':
                let works = await WorkModel.search(s, 10000, 0);
                if (service.benefits.length) {
                    works = works['filter']((sb: WorkModel) => {
                        return !service.works.some((b: any) => {
                            if (b.value) {
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ workSearchResult: s ? works as WorkModel[] : [] } as any);
                break;
            case 'FriendlyServices':
                let friendlyServices = await ServiceModel.searchService(s, 10000, 0, false, service.id ? service.id : '');
                if (service.friendlyServices.length) {
                    friendlyServices = friendlyServices['filter']((sb: ServiceModel) => {
                        return !service.friendlyServices.some((b: any) => {
                            if (b.value) {
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ firendlyServiceSearchResult: s ? friendlyServices as ServiceModel[] : [] } as any);
                break;
            case 'Projects':
                let projects = await ProjectModel.searchProject(s, 10000, 0, false);
                if (service.friendlyServices.length) {
                    projects = projects['filter']((sb: ProjectModel) => {
                        return !service.projects.some((b: any) => {
                            if (b.value) {
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ projectSearchResult: s ? projects as ProjectModel[] : [] } as any);
                break;
            case 'Reviews':
                let reviews = await ReviewModel.search(s, 10000, 0);
                if (service.reviews.length) {
                    reviews = reviews['filter']((sb: ReviewModel) => {
                        return !service.works.some((b: any) => {
                            if (b.value) {
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ reviewSearchResult: s ? reviews as ReviewModel[] : [] } as any);
                break;
            case 'Benefits':
                let benefits = await BenefitModel.searchBenefit(s, 10000, 0);
                if (service.benefits.length) {
                    benefits = benefits['filter']((sb: BenefitModel) => {
                        return !service.benefits.some((b: any) => {
                            if (b.value) {
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ benefitSearchResult: s ? benefits as BenefitModel[] : [] } as any);
                break;
            default:
                let postUsps = await ConclusionModel.searchConclusion(s, 10000, 0)
                if (service.conclusion) {
                    postUsps = postUsps['filter']((u: any) => u.id !== service.conclusion.value.id)
                }
                this.setState({ postUspSearchResult: s ? postUsps as ConclusionModel[] : [] } as any);
                break;

        }
    }

    public onAnotherPost() {
        this.setState({ service: new ServiceModel(), isNextStepAfterServiceCreationDialogOpen: false } as any)
    }


    public async onServiceSave() {
        const { service } = this.state;
        this.setState({ loading: true } as any);
        service.usp = service.usp.value ? service.usp.value : service.usp;
        service.grabForm = service.grabForm.value ? service.grabForm.value : service.grabForm;
        service.conclusion = service.conclusion.value ? service.conclusion.value : service.conclusion;
        service.benefits = service.benefits.map((b: any) => {
            return b.value ? b.value : b
        })
        service.friendlyServices = service.friendlyServices.map((b: any) => {
            return b.value ? b.value : b
        })
        service.projects = service.projects.map((b: any) => {
            return b.value ? b.value : b
        })
        service.works = service.works.map((b: any) => {
            return b.value ? b.value : b
        })
        service.reviews = service.reviews.map((b: any) => {
            return b.value ? b.value : b
        })
        await service.saveFullService()
        service.usp = { label: service.usp.name, value: service.usp }
        service.grabForm = { label: service.grabForm.name, value: service.grabForm }
        service.conclusion = { label: service.conclusion.name, value: service.conclusion }
        service.benefits = service.benefits.map((b: any) => {
            return { label: b['name'], value: b }
        })
        service.works = service.works.map((b: any) => {
            return { label: b['adminName'], value: b }
        })
        service.friendlyServices = service.friendlyServices.map((b: any) => {
            return { label: b['title']['ru'], value: b }
        })
        service.projects = service.projects.map((b: any) => {
            return { label: b['title']['ru'], value: b }
        })
        service.reviews = service.reviews.map((b: any) => {
            return { label: b['name'], value: b }
        })
        this.setState({ loading: false, service, isNextStepAfterServiceCreationDialogOpen: true } as any);
    }

    public onCloseDialog() {
        this.setState({ service: this.state.service, isNextStepAfterServiceCreationDialogOpen: false } as any);
    }

    public dashboard_render(): JSX.Element {
        const { projectSearchResult, reviewSearchResult, formSearchResult, workSearchResult, firendlyServiceSearchResult, service, loading, isNextStepAfterServiceCreationDialogOpen, benefitSearchResult, uspSearchResult, postUspSearchResult } = this.state;
        return <View
            reviewSearchResult={reviewSearchResult}
            projectSearchResult={projectSearchResult}
            formSearchResult={formSearchResult}
            workSearchResult={workSearchResult}
            firendlyServiceSearchResult={firendlyServiceSearchResult}
            accessAvailable={this.accessAvailable}
            onAnotherCreation={() => this.onAnotherPost()}
            onSearchContent={(s: string, t: string) => this.onSearchContent(s, t)}
            model={service}
            loading={loading}
            onSave={() => this.onServiceSave()}
            isNextStepAfterCreationDialogOpen={isNextStepAfterServiceCreationDialogOpen}
            onCreateContent={(t: string) => this.onCreateContent(t)}
            benefitSearchResult={benefitSearchResult}
            uspSearchResult={uspSearchResult}
            postUspSearchResult={postUspSearchResult}
            // tslint:disable-next-line:jsx-no-lambda
            onBack={() => this.goBack()}
            onDialogClose={() => this.onCloseDialog()}
        />
    }
}

export default ServiceAddEditViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/services/addedit/ServiceAddEditViewController.tsx